var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "decorate" },
    [
      _c(
        "el-form",
        {
          attrs: {
            "label-position": "top",
            "label-width": "80px",
            model: _vm.datas,
            rules: _vm.rules,
            size: "small",
          },
        },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: "页面名称",
                "hide-required-asterisk": true,
                prop: "name",
              },
            },
            [
              _c("el-input", {
                attrs: {
                  placeholder: "页面标题",
                  maxlength: "25",
                  "show-word-limit": "",
                },
                model: {
                  value: _vm.datas.name,
                  callback: function ($$v) {
                    _vm.$set(_vm.datas, "name", $$v)
                  },
                  expression: "datas.name",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              attrs: {
                label: "页面描述",
                "hide-required-asterisk": true,
                prop: "details",
              },
            },
            [
              _c("el-input", {
                attrs: {
                  placeholder: "用户通过微信分享给朋友时，会自动显示页面描述",
                },
                model: {
                  value: _vm.datas.details,
                  callback: function ($$v) {
                    _vm.$set(_vm.datas, "details", $$v)
                  },
                  expression: "datas.details",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { staticClass: "lef", attrs: { label: "页面类型", prop: "type" } },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.datas.type,
                    callback: function ($$v) {
                      _vm.$set(_vm.datas, "type", $$v)
                    },
                    expression: "datas.type",
                  },
                },
                [
                  _c("el-radio", { attrs: { label: "1", value: "1" } }, [
                    _vm._v("主页"),
                  ]),
                  _vm._v(" "),
                  _c("el-radio", { attrs: { label: "2", value: "2" } }, [
                    _vm._v("其他页"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              class: _vm.datas.type == 1 ? "disab" : "",
              attrs: {
                label: "页面标识",
                "hide-required-asterisk": true,
                prop: "pageIndex",
              },
            },
            [
              _c("el-input", {
                attrs: {
                  disabled: _vm.datas.type == 1,
                  placeholder: "页面标识",
                },
                model: {
                  value: _vm.datas.pageIndex,
                  callback: function ($$v) {
                    _vm.$set(_vm.datas, "pageIndex", $$v)
                  },
                  expression: "datas.pageIndex",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "背景颜色", prop: "backgroundColor" } },
            [
              _c("el-color-picker", {
                staticClass: "picke",
                attrs: { "show-alpha": "", predefine: _vm.predefineColors },
                model: {
                  value: _vm.datas.backgroundColor,
                  callback: function ($$v) {
                    _vm.$set(_vm.datas, "backgroundColor", $$v)
                  },
                  expression: "datas.backgroundColor",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "背景图片", prop: "backgroundImg" } },
            [
              _c(
                "el-upload",
                {
                  staticClass: "upload-demo",
                  attrs: {
                    "http-request": _vm.handlePictureUpload,
                    action: "",
                    "on-remove": _vm.handleRemoveFile,
                    "on-preview": _vm.handlePreview,
                    "list-type": "picture-card",
                    "auto-upload": true,
                    accept: "image/*",
                    "file-list": _vm.backgroundFileList,
                    limit: 1,
                  },
                },
                [_c("i", { staticClass: "el-icon-plus" })]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "upload-tip" }, [
                _vm._v(
                  "图片格式：jpg/png，大小≤2MB，建议尺寸315px*120px，或同比例图片"
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }